var render, staticRenderFns
import script from "./SchoolCards.vue?vue&type=script&lang=js&"
export * from "./SchoolCards.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCards.vue?vue&type=style&index=0&id=95fcd5b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports